"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToTransform() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const line1 = "Architecting your";
  const line2Part1 = "data-driven ";
  const line2Italic = "future.";
  const renderLetters = (text: string, baseDelay: number, italic = false) => text.split("").map((char, i) => <span key={`${text}-${i}`} data-index={i} className={`inline-block transition-all duration-700 ease-out ${italic ? "italic" : ""} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
    transitionDelay: `${baseDelay + i * 25}ms`
  }}>
        {char === " " ? "\u00A0" : char}
      </span>);
  return <section data-section-id="2250" id="ready-to-transform" className="dark text-foreground relative overflow-hidden font-default bg-accent">
      {}
      <div className="pointer-events-none absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-1/4 w-[800px] h-[500px] rounded-lg opacity-40 blur-3xl" style={{
      background: "radial-gradient(circle at center, var(--chart-2) 0%, transparent 70%)"
    }} aria-hidden="true" />

      
    </section>;
}